import { render, staticRenderFns } from "./kefuChat.vue?vue&type=template&id=e8ac1f08&scoped=true&"
import script from "./kefuChat.vue?vue&type=script&lang=js&"
export * from "./kefuChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ac1f08",
  null
  
)

export default component.exports